import {
    ApplicationConfig,
    inject,
    LOCALE_ID,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners
} from '@angular/core';
import {provideTranslateService} from "@ngx-translate/core";
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {DateAdapter} from "@angular/material/core";
import {CustomDateAdapter} from "./core/utils/date.utils";
import {WINDOW_PROVIDERS} from "./services/windows.service";
import {provideRouter, withInMemoryScrolling} from "@angular/router";
import {appRoutes} from "./app.routes";
import {provideClientHydration, withNoIncrementalHydration} from "@angular/platform-browser";
import localeDe from '@angular/common/locales/de';
import {registerLocaleData} from "@angular/common";
import {LanguageService} from "./services/language.service";
import {BackendErrorInterceptor} from "./core/error/backend-error.interceptor";

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
    providers: [
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: 'assets/i18n/',
                suffix: '.json'
            })
        }),
        provideAppInitializer(() => {
            const translate = inject(LanguageService);
            return translate.init();
        }),
        {provide: DateAdapter, useClass: CustomDateAdapter},
        {provide: LOCALE_ID, useValue: 'de'},
        WINDOW_PROVIDERS,
        provideRouter(appRoutes, withInMemoryScrolling({anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'})),
        provideBrowserGlobalErrorListeners(),
        provideClientHydration(withNoIncrementalHydration()),
        {provide: HTTP_INTERCEPTORS, useClass: BackendErrorInterceptor, multi: true},
        provideHttpClient(withInterceptorsFromDi(), withFetch())
    ]
};
